import type { SVGProps } from 'react';
import * as React from 'react';

const SvgWindDirection = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 12" width="1em" height="1em" {...props}>
    <path
      d="m.534 1.041 3.787 10.414c.231.634 1.128.634 1.358 0L9.466 1.041A.722.722 0 0 0 8.464.148l-3.14 1.57a.72.72 0 0 1-.646 0L1.538.148a.722.722 0 0 0-1.002.893H.534Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgWindDirection;
